import { createSelector } from 'reselect';
import _ from 'lodash';

const dropboxesSelector = state => state.dropboxes;

const getSortedDropboxes = (dropboxes) => {
    return (
        _.orderBy(
            dropboxes,
            [
                (dropbox) => {
                    return dropbox.semester.year;
                },
                (dropbox) => {
                    return dropbox.semester.season;
                },
                (dropbox) => {
                    return dropbox.name;
                }
            ],
            ['desc', 'asc', 'asc']
        )
    );
};

export default createSelector(
    dropboxesSelector,
    getSortedDropboxes
);


/** WEBPACK FOOTER **
 ** ./src/selectors/SortedDropboxesSelector.js
 **/